import { apiCall } from "../../../utils/api.utils";
import { API_URLS } from "../../../constants/apiUrls";

export const issuerConfigService = {
  getAllIssuerConfigs,
  createIssuerConfig,
  viewIssuerConfig
};

function getAllIssuerConfigs(params) {
  return apiCall(
    "GET",
    `${API_URLS.ISSUER_CONFIG.GET_CONFIGS}`,
    null,
    null,
    params
  );
}

function createIssuerConfig(request, id) {
  const method = id ? "PUT" : "POST";
  return apiCall(method, API_URLS.ISSUER_CONFIG.CONFIG_URI, null, request);
}

function viewIssuerConfig(configName, issuer) {
  return apiCall(
    "GET",
    `${API_URLS.ISSUER_CONFIG.CONFIG_URI}/${issuer}`,
    null,
    null,
    {
      configName
    }
  );
}
